import {
  DELETE_COMENTARIO_PACIENTE_START,
  DELETE_COMENTARIO_PACIENTE_SUCCESS,
  DELETE_COMENTARIO_PACIENTE_ERROR
} from '../../actions'

const initialState = {
  loading: false,
  payload: null,
  error: null
}

const paciente = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case DELETE_COMENTARIO_PACIENTE_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case DELETE_COMENTARIO_PACIENTE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case DELETE_COMENTARIO_PACIENTE_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state

  }

}

export default paciente